import {AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {ExgApplicationTabService} from 'exc-tab-v2';
import {ExcRestService, IExcDataDistinct, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {ExgDataTableComponent, ExgModalService, ExgTableSettingsComponent} from 'exc-controls-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ApplicationService} from '../../services/application.service';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExgApplicationEventEmitter} from '../../misc/classes/ExgApplicationEventEmitter';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {BehaviorSubject} from 'rxjs';
import {ExgFilterComponent} from '../../misc/exg-filter/exg-filter.component';
import {ExgFilterChipsComponent} from '../../misc/exg-filter-chips/exg-filter-chips.component';

@Component({
  selector: 'app-modal-select-task',
  templateUrl: './modal-select-task.component.html',
  styles: [
  ]
})
export class ModalSelectTaskComponent extends ExcTranslation implements OnInit, AfterViewInit {
  @Input() data: any;

  @ViewChild('VCtaskTable', {read: ExgDataTableComponent})
  VCtaskTable!: ExgDataTableComponent;
  @ViewChild('VCtaskTableFilterControl', {read: ExgFilterComponent})
  VCtaskTableFilterControl!: ExgFilterComponent;
  @ViewChild(ExgTableSettingsComponent) VCtableDefinitionSettings!: ExgTableSettingsComponent;
  @ViewChild('VCtaskTableSortControl', {read: ExgFilterComponent})
  VCtaskTableSortControl!: ExgFilterComponent;
  @ViewChild('VCtaskTableSearchControl', {read: ExgFilterComponent})
  VCtaskTableSearchControl!: ExgFilterComponent;
  @ViewChild('VCFilterChips')
  VCFilterChips!: ExgFilterChipsComponent;
  /****************************/
  Events = new ExgApplicationEventEmitter();
  /****************************/
  taskTable = {
    selectKey: 'vorgID',
    multiSelection: false,
    prefilter: 0,
    state: 1,
    selectedRow: undefined as any,
    selectedRows: [] as any[],
    selectedRowsClone: [] as any[],
    searchValue: '',
    uiFilterEnumGroup: [
      {
        enmName: 'Schadenart',
        enmField: 'aue_enmIdent_SchadenArt',
        enmTable: 'AuftragE_EIS',
        enmAlt: false,
        enmAltTT: true
      },
      {
        enmName: 'VorgangStatus',
        enmField: 'vorg_enmIdent_VorgangStatus',
        enmTable: 'Vorgang',
      },
      {
        enmName: 'VorgangTyp',
        enmField: 'vorg_enmIdent_VorgangTyp',
        enmTable: 'Vorgang',
      },
      {
        enmName: 'Versicherungsart',
        enmField: 'aue_enmIdent_Versicherungsart',
        enmTable: 'AuftragE_EIS',
      },
      // {enmName: 'AuftragTyp', enmField: 'au_enmIdent_AuftragTyp', enmTable: 'Auftrag'}
    ],
    uiFilterSearchFields: [
      {table: 'Vorgang', tableField: 'vorgNr'},
      {table: 'Vorgang', tableField: 'vorgBearbeiter', tableFieldCaptionAlt: this.getRessource('TableRenames.Bearbeiter')},
      // {table: 'Vorgang', tableField: 'Bearbeiter_Handy'},
      {table: 'Vorgang', tableField: 'vorgFrist'},
      {table: 'All', tableField: 'vorgLCU', groupCaption: 'Vorgang'},
      {table: 'All', tableField: 'vorgLCD', groupCaption: 'Vorgang'},
      {table: 'All', tableField: 'vorgCKD', groupCaption: 'Vorgang'},
      {table: 'AuftragE_EIS', tableField: 'aueSchadenNr', groupCaption: 'Schaden'},
      {table: 'AuftragE_EIS', tableField: 'aueVersicherungsnehmer', groupCaption: 'Schaden'},
      {table: 'AuftragE_EIS', tableField: 'aueSchadenOrt', groupCaption: 'Schaden'},
      {table: 'Auftrag', tableField: 'auAuftraggeberShort', repColumn: 'au_oeID_Auftraggeber'},
      {table: 'Auftrag', tableField: 'auAnsprechpartner'},
    ],
    uiSortFieldGroup: [
      {fieldGroup: 'Vorgang', fieldTable: 'Vorgang', fieldName: 'vorgNr'},
      {fieldGroup: 'Vorgang', fieldTable: 'Vorgang', fieldName: 'vorgFrist'},
      {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgLCD'},
      {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCRD'},
      {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCKD'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenNr'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenDatum'},
      {fieldGroup: 'Auftrag', fieldTable: 'Auftrag', fieldName: 'aueVersicherungsnehmer'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueAuftragsdatum'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtsterminPlan'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin2'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenmeldungVU'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueFristverlaengerungBis'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueZwischenberichtDatum'},
    ],
    uiFilter: [] as any[],
    uiSort: [] as any[],
    uiSortAktiv(): any[] {
      return this.uiSort.filter((sort: any) => sort.uiValue !== 0);
    },
    uiFilterAktiv(filterType?: number): any[] {
      return this.uiFilter
        .filter((filters: any) => !filterType || (filterType && filterType === filters.filterType))
        .filter((filters: any) =>
          ((filters.uiValue === true && filters.filterType === 1) ||
            (filters.filterCondition.value.length > 0 &&
              filters.filterType === 2))
        );
    },
    data: [] as any[],
    tableDefinition: [] as any[],
    distinctData: [] as any[],
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 24} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
      dataDistinct: {} as IExcDataFilter,
    } as IExcMetaInfo,
    paging: {
      pagingPage: 0,
      pagingEndRow: 0,
      pagingPageSize: 24,
      pagingTotalPages: 0,
      pagingTotalRows: 0,
      pagingStartRow: 0,
    },
    isLoading: true,
    toggleMultiSelection: (): void => {
      if (!this.taskTable.multiSelection) {
        this.taskTable.selectedRow = [];
        this.taskTable.selectedRows = [];
        this.taskTable.multiSelection = true;
      } else if (this.taskTable.multiSelection) {
        this.taskTable.selectedRow = [];
        this.taskTable.selectedRows = [];
        this.taskTable.multiSelection = false;
        this.taskTable.loadData();
      }
    },
    ready: () => {
      if (!this.taskTable.data || this.taskTable.data.length === 0) {
        this.taskTable.state = 2;

        if (this.VCtaskTable) {
          this.VCtaskTable.selectedRow = -1;
        }
      } else {
        this.taskTable.state = 0;

        if (this.VCtaskTable) {
          this.VCtaskTable.selectedRow = 0;
        }
      }
      this.init = false;
      this.taskTable.isLoading = false;
      this.tableIsLoading.next(this.taskTable.isLoading);
    },
    selectionChanged: (index: number) => {
      if (!this.taskTable.multiSelection) {
        const selection = this.taskTable.data[index];
        this.taskTable.selectedRows = [selection.vorgID];
      }
    },
    pageChanged: (page: number) => {
      if (this.taskTable.MetaInfo.dataPaging !== undefined) {
        this.taskTable.MetaInfo.dataPaging.pageNo = page;
      }
      this.taskTable.loadData();
    },
    search: (value: string) => {
      this.taskTable.searchValue = value;
      this.taskTable.pageChanged(1);
    },
    loadData: () => {
      const SELF = this;
      SELF.taskTable.state = 1;
      SELF.taskTable.isLoading = true;
      SELF.tableIsLoading.next(SELF.taskTable.isLoading);
      SELF.excRest
        .sget(
          SELF.excRest.computeUrl('TaskR_List', {
            auID: this.data.entityID,
            filter: this.taskTable.prefilter,
            fts: this.taskTable?.searchValue,
          }),
          'taskListState',
          {
            MetaInfo: {
              dataPaging: this.taskTable.MetaInfo.dataPaging,
              dataSort: this.taskTable.MetaInfo.dataSort,
              dataFilter: this.taskTable.MetaInfo.dataFilter
            }
          }
        )
        .subscribe((response: any) => {
          if (response.success && response.data) {
            SELF.taskTable.data = response.data.Vorgaenge;
            SELF.taskTable.paging = response.paging.Vorgaenge;
          } else {
            SELF.taskTable.data = [];
            SELF.taskTable.paging = {
              pagingPage: 0,
              pagingEndRow: 0,
              pagingPageSize: 25,
              pagingTotalPages: 0,
              pagingTotalRows: 0,
              pagingStartRow: 0,
            };
          }
          SELF.taskTable.ready();
        });
    },
    getDistinctData: (dataDistinct: IExcDataDistinct) => {
      this.taskTable.MetaInfo.dataDistinct = dataDistinct;
      this.excRest
        .sget(
          this.excRest.computeUrl('TaskR_List', {
            auID: this.data.entityID,
            filter: this.taskTable.prefilter,
            fts: this.taskTable?.searchValue,
          }),
          ExcCoreModule.Guid.NewGuid(),
          {MetaInfo: this.taskTable.MetaInfo}
        ).subscribe((ret: any) => {
        this.taskTable.distinctData = ret.data;
      });
    }
  };

  tableIsLoading = new BehaviorSubject(this.taskTable.isLoading);
  init = true;
  enableMultiSelection = true;
  preFilterDefinition: any[] = [];
  selectedMod: any;
  selectedType: any;

  constructor(
    private chDecRef: ChangeDetectorRef,
    private exgApplicationTabService: ExgApplicationTabService,
    public excRest: ExcRestService,
    public excSecurity: ExcSecurityService,
    private modalSvc: ExgModalService,
    public enumSvc: EnumerationService,
    public appSvc: ApplicationService,
    ) {
    super();
  }

  ngOnInit(): void {
    this.initialize();
    this.initTableDefinition();

    if (this.data && this.data.length > 0) {
      this.taskTable.multiSelection = true;
    }

    if (this.data.disableMultiSelect) {
      this.enableMultiSelection = false;
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (!this.selectedMod) {
        this.selectedMod = this.preFilterDefinition[3];
      }
      this.selectedType = this.selectedMod.types.find((i: any) => {
        return i.value === String(this.taskTable.prefilter);
      });
      this.VCtaskTableFilterControl.ApplyFilter();

      if (this.data && this.data.length > 0) {
        for (const preSelection of this.data) {
          this.taskTable.selectedRows.push(preSelection.vorgID);
        }
      }
    });
  }

  initialize(): void {
    const SELF = this;

    SELF.initEnumerations();
    SELF.taskTable.loadData();

    SELF.preFilterDefinition = [
      {
        value: 'active',
        get caption(): string {
          return SELF.getRessource(this.value + '.caption');
        },
        types: [
          {
            value: '1',
            get caption(): string {
              return SELF.enumSvc.getEnumerationText('AuftragStatus', Number(this.value));
            },
          },
          {
            value: '2',
            get caption(): string {
              return SELF.enumSvc.getEnumerationText('AuftragStatus', Number(this.value));
            },
          },
          {
            value: '3',
            get caption(): string {
              return SELF.enumSvc.getEnumerationText('AuftragStatus', Number(this.value));
            },
          },
          {
            value: '4',
            get caption(): string {
              return SELF.enumSvc.getEnumerationText('AuftragStatus', Number(this.value));
            },
          },
          {
            value: '7',
            get caption(): string {
              return SELF.enumSvc.getEnumerationText('AuftragStatus', Number(this.value));
            },
          },
          {
            value: '9',
            get caption(): string {
              return SELF.enumSvc.getEnumerationText('AuftragStatus', Number(this.value));
            },
          },
          {
            value: '0',
            get caption(): string {
              return SELF.getRessource('active.' + this.value);
            },
          },
        ],
      },
      {
        value: 'closed',
        get caption(): string {
          return SELF.getRessource(this.value + '.caption');
        },
        types: [
          {
            value: '51',
            get caption(): string {
              return SELF.getRessource('closed.' + this.value);
            },
          },
          {
            value: '52',
            get caption(): string {
              return SELF.getRessource('closed.' + this.value);
            },
          },
          {
            value: '53',
            get caption(): string {
              return SELF.getRessource('closed.' + this.value);
            },
          }
        ],
      },
      {
        value: 'cancelled',
        get caption(): string {
          return SELF.getRessource(this.value + '.caption');
        },
        types: [
          {
            value: '61',
            get caption(): string {
              return SELF.getRessource('cancelled.' + this.value);
            },
          },
          {
            value: '62',
            get caption(): string {
              return SELF.getRessource('cancelled.' + this.value);
            },
          },
          {
            value: '63',
            get caption(): string {
              return SELF.getRessource('cancelled.' + this.value);
            },
          }
        ],
      },
      {
        value: 'all',
        get caption(): string {
          return SELF.getRessource(this.value + '.caption');
        },
        types: [
          {
            value: '-1',
            get caption(): string {
              return SELF.getRessource('all.' + this.value);
            },
          },
        ],
      },
    ];
    for (let i = new Date().getFullYear(); i >= new Date().getFullYear() - 3; i--)
    {
      SELF.preFilterDefinition[1].types.push(
        {
          value: '-5' + i,
          get caption(): string {
            return i as unknown as string;
          },
        }
      );
      SELF.preFilterDefinition[2].types.push(
        {
          value: '-6' + i,
          get caption(): string {
            return i as unknown as string;
          },
        }
      );
    }
    SELF.preFilterDefinition[1].types.push(
      {
        value: '5',
        get caption(): string {
          return SELF.getRessource('closed.' + this.value);
        },
      }
    );
    SELF.preFilterDefinition[2].types.push(
      {
        value: '6',
        get caption(): string {
          return SELF.getRessource('cancelled.' + this.value);
        },
      }
    );
    SELF.selectedMod = SELF.preFilterDefinition[0];

    this.taskTable.prefilter = 0;
  }

  initEnumerations(): void {
    this.taskTable.uiFilter = this.appSvc.metaInfo.dataFilter(
      this.taskTable.uiFilterEnumGroup,
      this.taskTable.uiFilterSearchFields);
    this.taskTable.uiSort = this.appSvc.metaInfo.dataSort(this.taskTable.uiSortFieldGroup);
  }

  initTableDefinition(): void {
    this.taskTable.tableDefinition = [
      {
        caption: this.enumSvc.getFieldCaption('Vorgang', 'vorgNr') + '    '
        , value: 'vorgNr'
        , fixed: true, align: 0, sort: 0, ordinal: 0, visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenNr')
        , value: 'aueSchadenNr'
        , fixed: true, align: 0, sort: 0, ordinal: 0, visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Auftrag', 'aueVersicherungsnehmer')
        , value: 'aueVersicherungsnehmer'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenOrt')
        , value: 'aueSchadenOrt'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Auftrag', 'au_oeID_Auftraggeber')
        , value: 'auAuftraggeberShort'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_SchadenArt')
        , value: 'aue_enmIdent_SchadenArt'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('Schadenart', value);
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_Versicherungsart')
        , value: 'aue_enmIdent_Versicherungsart'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('Versicherungsart', value);
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('Vorgang', 'vorg_enmIdent_VorgangTyp')
        , value: 'vorg_enmIdent_VorgangTyp'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('VorgangTyp', value);
        }
      },
      {
        caption: this.getRessource('TableRenames.Bearbeiter')
        , value: 'vorgBearbeiter'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.getRessource('TableRenames.lastSV')
        , value: 'aueLetzterSachverstaendiger'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.getRessource('TableRenames.lastSP')
        , value: 'aueLetzterSanierungspartner'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.getRessource('TableRenames.OrtsterminIst')
        , value: 'aueOrtstermin'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateFormat')
        , visible: true
      },
      {
        caption: this.getRessource('TableRenames.OrtsterminPlan')
        , value: 'aueOrtsterminPlan'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date'
        , dateFormat: this.getGlobal('DateFormat')
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%CKU')
        , value: 'vorgCKU'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%CKD')
        , value: 'vorgCKD'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateTimeFormatShort')
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%LCU')
        , value: 'vorgLCU'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%LCD')
        , value: 'vorgLCD'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateTimeFormatShort')
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Vorgang', 'vorgFristDiff')
        , value: 'vorgFristDifference'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Vorgang', 'vorgFrist')
        , value: 'vorgFrist'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateFormat')
        , visible: true
      },
      {
        caption: this.getRessource('TableRenames.AbrechnungsHinweis')
        , value: 'aueAbrechnungshinweis_enmIdent'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return value ? this.enumSvc.getEnumerationText('Abrechnungshinweis', value) : '';
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('Vorgang', 'vorg_enmIdent_VorgangStatus')
        , value: 'vorg_enmIdent_VorgangStatus'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('VorgangStatus', value);
        }
      },
    ];
  }

  changePreFilterMod(event: any): void {
    this.selectedMod = event;
    // this.messageTable.prefilterMod = event.value;
    this.changePreFilterType(this.selectedMod.types[0]);
  }

  changePreFilterType(event: any): void {
    this.selectedType = event;
    this.taskTable.prefilter = event.value;
    this.VCtaskTableFilterControl.ApplyFilter();
  }

  openTableSettings($event: any): void {
    this.VCtableDefinitionSettings.openFilterConfig($event);
  }

  action(): void {
    if (!this.dirty()) {
      this.modalSvc.action(this.taskTable.selectedRows);
    }
  }

  close(): void {
    this.modalSvc.close();
  }

  dirty(): boolean {
    return (
      this.taskTable.selectedRows.length === 0
      || (
        JSON.stringify(this.taskTable.selectedRowsClone) === JSON.stringify(this.taskTable.selectedRows)
      )
    );
  }
}
